/* eslint-disable max-len */
import 'react';

const LoadErrorSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const id = Date.now();
    const id1 = `loadErrorSvg-1-${id}`;
    const id2 = `loadErrorSvg-2-${id}`;

    return (
        <svg width="118px" height="77px" viewBox="0 0 118 77" {...props} >
            <defs>
                <linearGradient x1="50%" y1="6.92408969e-06%" x2="50%" y2="99.9999931%" id={id1}>
                    <stop stopColor="#E9EFFC" offset="0.1193042%"></stop>
                    <stop stopColor="#DCE5FA" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id={id2}>
                    <stop stopColor="#E2E8F9" offset="0.1193042%"></stop>
                    <stop stopColor="#CED9F4" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-661.000000, -345.000000)" fillRule="nonzero">
                    <g transform="translate(630.000000, 256.000000)">
                        <g transform="translate(31.000000, 89.000000)">
                            <g fill="#F7F9FD">
                                <path d="M117.95,48.75 C117.1,39 107.05,38.4 97.55,36.9 C88.05,35.4 87.3,28 94.05,22.15 C100.8,16.3 105.4,5.85 97,1.4 C88.15,-3.3 75.15,5.25 47.95,8.85 C27.35,11.55 16.45,13.95 8.35,18.35 C-2.15,24.05 -1.35,33.3 6.15,36.15 C16.05,39.9 22.9,43.5 18.65,50.2 C14.4,56.9 1.85,58 2.2,67.05 C2.7,80.1 55.05,77.45 81.55,72.1 C101.45,68.1 118.85,58.45 117.95,48.75 Z" ></path>
                            </g>
                            <path d="M54.65,7.9 L93.75,18.4 C96.95,19.25 98.85,22.55 98,25.75 L86.4,65.4 C85.55,68.6 82.25,70.5 79.05,69.65 L39.95,59.15 C36.75,58.3 34.85,55 35.7,51.8 L47.3,12.15 C48.2,8.95 51.45,7.05 54.65,7.9 Z" fill={`url(#${id1})`}></path>
                            <path d="M76.4,63.85 C76.4,67.2 73.7,69.85 70.4,69.85 L31.7,69.85 C28.4,69.85 25.7,67.15 25.7,63.85 L25.7,13.15 C25.7,9.8 28.4,7.15 31.7,7.15 L59.85,7.15 L76.4,23.65 L76.4,63.85 L76.4,63.85 Z" fill={`url(#${id2})`}></path>
                            <path d="M76.4,23.5 L66,23.5 C62.7,23.5 60.05,20.85 60.05,17.55 L60.05,7.15 L76.4,23.5 Z" fill="#F4F7FF"></path>
                            <path d="M55.65,30.95 C55.65,31.3 55.6,31.65 55.5,32 L54,43.95 L54,43.95 C53.85,45.35 52.6,46.45 51,46.45 C49.4,46.45 48.15,45.35 48,43.95 L48,43.95 L46.5,32 C46.4,31.65 46.35,31.35 46.35,30.95 C46.35,30.9 46.35,30.85 46.35,30.85 L46.35,30.8 L46.35,30.8 C46.45,28.6 48.5,26.8 50.95,26.8 C53.4,26.8 55.45,28.55 55.55,30.8 L55.55,30.8 L55.55,30.85 C55.65,30.85 55.65,30.9 55.65,30.95 Z M51.05,48.6 C52.7,48.6 54.05,49.95 54.05,51.6 C54.05,53.25 52.7,54.6 51.05,54.6 C49.4,54.6 48.05,53.25 48.05,51.6 C48.05,49.95 49.4,48.6 51.05,48.6 Z" fill="#F5F8FF"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
export default LoadErrorSvg;
